import {
    useMemo,
} from 'react'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import usePricingRoutes from 'app/SkyNetRoutes/hooks/usePricingRoutes'
import useEnumValues from 'app/hooks/useEnumValues'
import useGetContractBasis from 'app/Apps/Pricing/ContractBasis/hooks/useGetContractBasis'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'

import getFields, {
    ContractBasisInformationFields,
} from './ContractBasisInformationForm.fields'

export default function ContractBasisInformationForm({
    id,
    update,
    disabled = false,
}: Readonly<{
    id?: number,
    update?: (value: ContractBasisInformationFields) => void,
    disabled?: boolean
}>) {
    const getAllowedValues = useEnumValues()
    const {
        ContractBasis: ContractBasisRoutes,
    } = usePricingRoutes()

    const fields = useMemo(() => {
        return getFields({
            disabled,
            getAllowedValues,
            generateContractBasisLink: (contactBasisId: number | string) => {
                if (!contactBasisId) return null
                return generateSkyNetLink({
                    domainPath: ContractBasisRoutes.ContractBasis.path,
                    params: {
                        key: contactBasisId,
                    },
                })
            },
        })
    }, [
        ContractBasisRoutes.ContractBasis.path,
        disabled,
        getAllowedValues,
    ])

    const {
        data: contractBasis,
        isDataReady,
    } = useGetContractBasis(id)

    const value = useMemo(() => {
        if (isDataReady) {
            return {
                ...contractBasis,
                contractBasis: {
                    id: contractBasis.id,
                },
            }
        }
        return null
    }, [
        contractBasis,
        isDataReady,
    ])

    return (
        <DomainObjectForm
            name="ContractBasisInformationForm"
            value={value}
            fields={fields}
            onChange={update}
        />
    )
}
